import Select from 'react-select'
import { selectStyles } from 'apps/builder/components/shared'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { useDispatch } from 'react-redux'
import { lib } from '@gocanvas/client'
const { referenceDataHooks } = lib
const { useReferenceDataOptions } = referenceDataHooks

const specialDefaultOptions = [
  {
    label: 'Blank',
    text: 'GC_BLANK_DEFAULT',
    value: 'GC_BLANK_DEFAULT',
  },
  {
    label: 'First Choice',
    text: '',
    value: '',
  },
]

// TODO : potential useMemo speedup
const processOptions = (initialOptions, addSpecial) =>
  initialOptions.reduce(
    (acc, option) => {
      const { text, label } = option
      if (option.text) {
        acc.push({
          ...option,
          label: label || text,
          value: text,
        })
      }
      return acc
    },
    addSpecial ? [...specialDefaultOptions] : []
  )

export const DefaultValue = ({
  entry_values,
  guid,
  options: default_options = [],
  defaultValue,
  addSpecial,
  hasReferenceData,
  reference_data_id,
  reference_data_column,
}) => {
  const dispatch = useDispatch()

  const { options } = useReferenceDataOptions({
    reference_data_id,
    reference_data_column,
    default_options,
  })

  const defaultChoiceOptions = processOptions(options, addSpecial)

  let defaultOption

  if (defaultValue && defaultValue != 'GC_BLANK_DEFAULT') {
    defaultOption = defaultChoiceOptions.find(
      ({ text }) => text == defaultValue
    )
  } else if (defaultValue && defaultValue == 'GC_BLANK_DEFAULT') {
    defaultOption = defaultChoiceOptions[0]
  } else if (defaultValue == null) {
    defaultOption = null
  } else {
    defaultOption = defaultChoiceOptions[1]
  }

  const updateDefaultValue = ({ value }) => {
    dispatch(
      updateEntry({
        guid,
        default: value,
      })
    )
  }

  // TODO: remove if no longer allowing user to type any option value?
  // select search of existing options would be better in this case, imo
  // const SelectComponent = hasReferenceData ? CreatableSelect : Select
  // const defaultOptions = hasReferenceData
  //   ? [...defaultChoiceOptions, ...referenceDataOptions]
  //   ? [{ label: 'Type to enter your own', options: defaultChoiceOptions }]
  //   : defaultChoiceOptions

  return (
    <div className="label-floating">
      <Select
        styles={selectStyles}
        isDisabled={!entry_values.length && !hasReferenceData}
        className="input--placeholder default-value--select default--dropdown"
        classNamePrefix="react-select"
        onChange={updateDefaultValue}
        options={defaultChoiceOptions}
        value={defaultOption || ''}
      />
      <label className="label-default-value">Default Value</label>
    </div>
  )
}
